export enum Flipper {
  pickupBatching = 'rt_ftc_pickup_batching',
}
